"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.superScrabble = void 0;
const constants_1 = require("@scrabble-solver/constants");
const types_1 = require("@scrabble-solver/types");
exports.superScrabble = {
    bingo: { score: 50 },
    blankScore: 0,
    blanksCount: 4,
    boardHeight: 21,
    boardWidth: 21,
    game: types_1.Game.SuperScrabble,
    name: 'Super Scrabble',
    rackSize: 7,
    bonuses: [
        { multiplier: 4, type: constants_1.BONUS_WORD, x: 0, y: 0 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 0 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 7, y: 0 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 0 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 13, y: 0 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 17, y: 0 },
        { multiplier: 4, type: constants_1.BONUS_WORD, x: 20, y: 0 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 1, y: 1 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 4, y: 1 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 8, y: 1 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 12, y: 1 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 16, y: 1 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 19, y: 1 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 2 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 5, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 9, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 11, y: 2 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 15, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 18, y: 2 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 0, y: 3 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 3, y: 3 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 6, y: 3 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 10, y: 3 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 14, y: 3 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 17, y: 3 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 20, y: 3 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 1, y: 4 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 4, y: 4 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 4 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 12, y: 4 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 16, y: 4 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 19, y: 4 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 2, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 5, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 15, y: 5 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 18, y: 5 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 6 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 6, y: 6 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 6 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 14, y: 6 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 17, y: 6 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 0, y: 7 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 7, y: 7 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 13, y: 7 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 20, y: 7 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 1, y: 8 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 4, y: 8 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 8 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 12, y: 8 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 16, y: 8 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 19, y: 8 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 5, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 15, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 18, y: 9 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 0, y: 10 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 3, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 6, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 14, y: 10 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 17, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 20, y: 10 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 5, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 15, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 18, y: 11 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 1, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 4, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 12, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 16, y: 12 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 19, y: 12 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 0, y: 13 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 7, y: 13 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 13, y: 13 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 20, y: 13 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 14 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 6, y: 14 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 14 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 14, y: 14 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 17, y: 14 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 2, y: 15 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 5, y: 15 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 9, y: 15 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 11, y: 15 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 15, y: 15 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 18, y: 15 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 1, y: 16 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 4, y: 16 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 8, y: 16 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 12, y: 16 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 16, y: 16 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 19, y: 16 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 0, y: 17 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 3, y: 17 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 6, y: 17 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 10, y: 17 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 14, y: 17 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 17, y: 17 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 20, y: 17 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 2, y: 18 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 5, y: 18 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 9, y: 18 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 11, y: 18 },
        { multiplier: 4, type: constants_1.BONUS_CHARACTER, x: 15, y: 18 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 18, y: 18 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 1, y: 19 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 4, y: 19 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 8, y: 19 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 12, y: 19 },
        { multiplier: 3, type: constants_1.BONUS_CHARACTER, x: 16, y: 19 },
        { multiplier: 2, type: constants_1.BONUS_WORD, x: 19, y: 19 },
        { multiplier: 4, type: constants_1.BONUS_WORD, x: 0, y: 20 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 3, y: 20 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 7, y: 20 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 10, y: 20 },
        { multiplier: 3, type: constants_1.BONUS_WORD, x: 13, y: 20 },
        { multiplier: 2, type: constants_1.BONUS_CHARACTER, x: 17, y: 20 },
        { multiplier: 4, type: constants_1.BONUS_WORD, x: 20, y: 20 },
    ],
};
